import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-custom-avatar',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './custom-avatar.component.html',
  styleUrl: './custom-avatar.component.css'
})
export class CustomAvatarComponent {
  @Input() initials: string = ''; 
  @Input() imageUrl: string | null = null;
  @Input() backgroundColor: string = 'bg-secondary';
  @Input() textColor: string = 'text-white';
  @Input() textSize: string = 'text-2xl';
}
